import * as React from 'react'
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button } from '@mui/material'

const ComingSoonDialog = ({ open, handleClose }) => {
	return (
		<Dialog
			open={open}
			onClose={handleClose}
			aria-labelledby='coming-soon-dialog-title'
			sx={{ '& .MuiDialog-paper': { width: '600px', height: '400px' } }}
		>
			<DialogTitle id='coming-soon-dialog-title' sx={{ textAlign: 'center' }}>
				Coming Soon
			</DialogTitle>
			<DialogContent sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
				<DialogContentText>This feature is coming soon! Stay tuned for updates.</DialogContentText>
			</DialogContent>
			<DialogActions>
				<Button onClick={handleClose} color='primary' variant='contained'>
					Close
				</Button>
			</DialogActions>
		</Dialog>
	)
}

export default ComingSoonDialog
